import { ToolList } from './ToolList';
import { ToolCreate } from './ToolCreate';
import { ToolEdit } from './ToolEdit';
import { TaskList } from './TaskList';
import { TaskCreate } from './TaskCreate';
import { TaskEdit } from './TaskEdit';
import { CompanySettings } from './CompanySettings';

export {
  ToolList,
  ToolCreate,
  ToolEdit,
  TaskList,
  TaskCreate,
  TaskEdit,
  CompanySettings,
};

export default {
  ToolList,
  ToolCreate,
  ToolEdit,
  TaskList,
  TaskCreate,
  TaskEdit,
  CompanySettings,
};